import { useId } from 'react'
import { brandBeta } from '@lunary/ui-tokens'

type Props = { cx: number; cy: number; r: number; glyph: string; className?: string }

export function BrandBetaBadge({ cx, cy, r, glyph, className }: Props) {
  const id = `brand-beta-${useId().replace(/:/g, '')}`
  return (
    <>
      <mask id={id} maskUnits="userSpaceOnUse" x={cx - r} y={cy - r} width={r * 2} height={r * 2}>
        <rect x={cx - r} y={cy - r} width={r * 2} height={r * 2} fill="#fff" />
        <path
          transform={glyph}
          d={brandBeta.glyph}
          fill="none"
          stroke="#000"
          strokeWidth={brandBeta.glyphStroke}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </mask>
      <circle className={className} cx={cx} cy={cy} r={r} mask={`url(#${id})`} />
    </>
  )
}
